var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 20C15.5229 20 20 15.5229 20 10C20 4.47709 15.5229 0 10 0C4.47709 0 0 4.47709 0 10C0 15.5229 4.47709 20 10 20Z",
    fill: "#F45567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.97686 15.818C7.4314 15.818 5.61322 14.3635 5.61322 11.818C5.61322 7.99982 10.1587 7.63619 9.24958 4.18164C11.0678 5.63619 12.1587 6.72709 12.1587 9.27255C13.0678 8.72709 13.0678 6.90891 12.7041 5.45437C14.8859 7.99982 16.5454 15.818 9.97686 15.818Z",
    fill: "#FACB1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.41904 15.1885L14.203 8.40455C13.8703 7.30455 13.3787 6.31255 12.8441 5.62673C12.7974 5.56819 12.7503 5.50819 12.7041 5.45437C13.0678 6.90891 13.0678 8.72709 12.1587 9.27255C12.1587 6.72709 11.0678 5.63619 9.24958 4.18164C10.1587 7.63619 5.61322 7.99982 5.61322 11.818C5.61322 13.2433 6.19486 14.4707 7.41904 15.1885Z",
    fill: "#FBE158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.7951 12.5087C11.7951 13.5391 10.9871 14.3633 9.97687 14.3633C8.96669 14.3633 8.15869 13.5329 8.15869 12.5087C8.15869 10.6542 9.79506 10.836 9.79506 8.36328C10.1992 8.98146 11.7951 10.6542 11.7951 12.5087Z",
    fill: "#DF2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.79506 8.36328C9.79506 10.836 8.15869 10.6542 8.15869 12.5087C8.15869 13.0462 8.38233 13.5287 8.73996 13.8675L11.5114 11.096C11.0343 9.84601 10.0927 8.81837 9.79506 8.36328Z",
    fill: "#FA5655"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.13f7babb106a432b61e4d6acaf520dde.svg";
export { ForwardRef as ReactComponent };